import React, { Component } from 'react';
import {c_markers as colors, c_public_transport, c_railway, c_gradient_greens} from '../a-Graphic/Colors';
import {p_size_1, p_size_2, p_size_3, r_size_1} from '../a-Graphic/Layout';

import getMyMap, {createNamesLayer, createResidentialAreasMassLayer, createCommuneBordersLayer,
  getLegendMode, createPlacesLayer, createRoutesLayer, createGriddedLayer, createCommunesNamesLayerEasy} from '../b-LeafletMap/leaflet_map';

import LegendResidentialArea from '../b-LeafletMap/Legend/LegendResidentialArea';
import LegendPlace from '../b-LeafletMap/Legend/LegendPlace';
import LegendRoute from '../b-LeafletMap/Legend/LegendRoute';
import LegendValues from '../b-LeafletMap/Legend/LegendValues';

import Sources from '../f-Utilities/Sources'

class PublicTransport extends React.Component {
  constructor(props){
    super(props)

    this.mode = "ckmeans"
    this.colors = c_gradient_greens
  }

  componentDidMount() {
    /* PT ROUTES */
    var public_transport = this.props.territory.public_transport;
    var public_transport_routes = [];

    for (let pt of public_transport){
        let route = [];
        for (var i=0; i<pt.stops_lat.length; i++){
          route.push([pt.stops_lat[i], pt.stops_lon[i]])
        }
        public_transport_routes.push(route);
    }
    var public_transport_labels = public_transport.map((pt)=>pt.name)

    var railways = this.props.territory.railways.filter((r)=>r != null);

    /* PT STOPS AREAS */
    var stops_bus = [];
    public_transport.map((pt) => stops_bus = stops_bus.concat(pt.stops));
    var stops_bus_coords = stops_bus.map((a) => a.coords)
    var stops_bus_labels = stops_bus.map((a) => a.name)

    var places = this.props.territory.places;
    var train_stations = places.filter((p) => ["gare de voyageurs d'intérêt local", "gare de voyageurs d'intérêt régional", "gare de voyageurs d'intérêt national"].includes(p.type_fr.toLowerCase()))
    var train_stations_coords = train_stations.map((a) => a.coords)

    /* COMMUNES */
    var communes = this.props.territory.communes;
    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    /* GRIDDED POPULATION */
    var gridded_population = [].concat(...this.props.territory.communes.map((c)=>c.gridded_population));
    var pop_coords = gridded_population.map((c) => c.coords);
    var pop_masses = gridded_population.map((c) => parseInt(c.population));
    var pop_labels = gridded_population.map((c) => c.population + " - hab");

    /* RESIDENTIAL */
    var residential_areas = [];
    this.props.territory.communes.map((c) => residential_areas = residential_areas.concat(c.residential_areas));
    var ra_population = residential_areas.map((ra) => ra.population)
    var ra_labels = residential_areas.map((ra)=> ra.name + " - " + ra.population + " hab")

    // --- init map
    var mymap = getMyMap(this.props.id, true, 0.3);

    // --- create layers
    var communes_layer = createCommuneBordersLayer(mymap, communes)
    //createResidentialAreasMassLayer(mymap, residential_areas, ra_population, ra_labels);
    createGriddedLayer(mymap, pop_coords, pop_masses, pop_labels, this.mode, this.colors);
    createRoutesLayer(mymap, railways, null, r_size_1, c_railway);
    createRoutesLayer(mymap, public_transport_routes, public_transport_labels, r_size_1, c_public_transport);
    createPlacesLayer(mymap, stops_bus_coords, p_size_1/2 - 3, colors[0], stops_bus_labels);
    createPlacesLayer(mymap, train_stations_coords, p_size_1/2, colors[1]);
    createCommunesNamesLayerEasy(mymap, communes)
    //createNamesLayer(mymap, communes_coords, communes_names);

    // --- center the map
    mymap.fitBounds(communes_layer.getBounds());
  }


  render() {
    var gridded_population = [].concat(...this.props.territory.communes.map((c)=>c.gridded_population));
    var pop_masses = gridded_population.map((c) => parseInt(c.population));

    var [intervals, colors_legend] = getLegendMode(this.mode, pop_masses, this.colors);

    var public_transport = this.props.territory.public_transport;
    return(
      <div className="row content mt-4 mb-5">
        <div className="col-12">

          <div className="row">
            <div className="col-12">
              <h3 className="mb-3">transports en communs</h3>
            </div>
          </div>

          <div className="row align-items-end">
            <div className="col-9">
              <div style={{height: "600px"}} id={this.props.id}></div>

              <div className="row mt-1">
                <div className="col-10">
                 <Sources sources={this.props.territory.sources}
                        concerned={["gridded_pop", "osm", "transportdatagouv"]}/>
                </div>
              </div>

            </div>
            <div className="col-3">
                <div className="row">
                  <div className="col offset-4 pr-0 pl-0">
                   <p><b>Population du carreau</b></p>
                   <p><i>(carreau de 200m)</i></p>
                  </div>
                </div>
                 <LegendValues intervals={intervals} colors={colors_legend}/>
                 <div className="mt-4 mb-4"></div>
                 <LegendPlace color={colors[0]} size={p_size_1+2} label="Arrêt de transport en commun"/>
                 <LegendPlace color={colors[1]} size={p_size_1+2} label="Gare"/>
                 <div className="mt-4 mb-4"></div>
                 <LegendRoute color={c_public_transport.slice(0, public_transport.length)} size={r_size_1*2+1} label="Lignes de transport en commun"/>
                 <div className="mt-4 mb-4"></div>
                 <LegendRoute color={c_railway} size={r_size_1*2+1} label="Voie ferrée"/>
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default PublicTransport;
